import { render, staticRenderFns } from "./OperatorRightsTable.vue?vue&type=template&id=34687694&"
import script from "./OperatorRightsTable.vue?vue&type=script&lang=js&"
export * from "./OperatorRightsTable.vue?vue&type=script&lang=js&"
import style0 from "./OperatorRightsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports